<template>
  <div class="logo"
    :style="{ ...customStyle(),
      backgroundImage: generateBackgroundImage(),
      backgroundColor: generateBackgroundColor() }">
    <div v-if="user.name && !this.generateBackgroundImage()" class="name">
      {{user.name.charAt(0)}}
    </div>
    <slot class="name"></slot>
  </div>
</template>

<script>
import _ from 'lodash';
import colorGenerator from '@/utils/colorGenerator';

export default {
  mixins: [colorGenerator],
  props: {
    user: {
      default: '',
    },
    options: {
      type: Object,
      default: () => ({
        width: '36px',
        height: '36px',
        backgroundColor: null,
        color: null,
      }),
    },
  },
  methods: {
    generateBackgroundColor() {
      if (this.options && this.options.backgroundColor) {
        return this.options.backgroundColor;
      }
      return this.colorGenerator(this.user.name);
    },
    generateBackgroundImage() {
      const imageObject = _.get(this.user.displayImage, 'urls.cover80w80h', null);
      if (imageObject) {
        return `url(${imageObject})`;
      }
      return null;
    },
    customStyle() {
      return this.options;
    },
    getImageBySize(imageObject, size) {
      return _.get(imageObject.sizes, size, null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.logo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: $gray-700;
  color: $gray-200;

  display: flex;
  align-items: center;
  justify-content: center;

  text-transform: uppercase;
  font-size: $font-size-base * 1.25;

  background-size: cover;
  background-position: center center;

  .name {
    line-height: 0;
  }
}

</style>
